import { apiGet, apiPost } from './apiClient';

export async function login(credentials) {
  return apiPost('/wms/users/login', credentials, { includeAuth: false });
}

export async function getPermissions(token) {
  return apiGet('/wms/permissions', {
    token,
    params: {
      sortBy: 'sort',
      order: 'ASC',
      status: 1
    }
  });
}
